import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import {
  getAllSecurities,
  uploadPsxFile,
  getAllPsx,
  searchSecurityAPI,
  updateEquitySecurityStatus,
  bulkStatusChange,
  getAllFundSecurity,
  updateFundSecuritySecurityStatus,
} from "../../../stores/services/security.service";
import { ToastContainer, toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import { useHistory } from "react-router-dom";
import { ImCheckmark } from "react-icons/im";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import Button from "../../../components/ui/button";
import { useSelector } from "react-redux";
import { companyArr } from "../../../utils/ui_data";
import SetupEquitySecurity from "./setup-equity-security";
import EditEquitySecurity from "./edit-equity-security";
import ViewEquitySecurity from "./view-equity-security";
import { useCustomStylesDropDown } from "../../../assets/css/customStyle";
import { isNumber, numberWithCommas } from "../../../utils/customFunction";

const SecurityList = () => {
  const ActiveSecurity = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Active",
      value: "Active",
    },
    {
      label: "Inactive",
      value: "Inactive",
    },
    {
      label: "Future Active",
      value: "Future Active",
    },
    {
      label: "Future InActive",
      value: "Future InActive",
    },
  ];

  const moneyMarket = [
    { label: "Pakistan Investment Bonds", value: "PIB" },
    { label: "Treasury Bill", value: "TBILL" },
  ];
  const debtMarket = [
    { label: "Sukuk Certificates", value: "SUKUK" },
    { label: "Term Finance Certificates", value: "TFC" },
    { label: "Commercial Papers", value: "CP" },
  ];
  const termDeposits = [
    { label: "Term Deposit Receipts", value: "TDR" },
    { label: "Certificate Of Investment", value: "CDR" },
    { label: "Letter of Placement", value: "LOP" },
  ];
  const baiMujjalPlacement = [
    { label: "Bai Mujjal Placement", value: "Bai Mujjal Placement" },
  ];

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const history = useHistory();
  const filepath = new Date().toISOString().split("T")[0] + ".csv";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const email = sessionStorage.getItem("email") || "";
  const [data, setData] = useState<any>([]);
  const [Loading, setLoading] = useState(false);
  let [activePage, setActivePage] = useState("");
  const [isSearchActive, setSearchActive] = useState(false);
  let [paginationArr, setPaginationArr] = useState([""]);
  const [pageSize, setPageSize] = useState("10");

  const [statusSetPopup, setStatusSetPopup] = useState(false);
  const [currentBranchStatus, setCurrentBranchStatus] = useState("");
  const [symbol, setSymbol] = useState("");
  const [branchLoading, setbranchLoading] = useState(false);
  const [loadingAllStatusChange, setLoadingAllStatusChange] = useState(false);
  const [psxList, setPsxList] = useState<any>([]);
  const [tempPsxList, setTempPsxList] = useState<any>([]);
  const [filterSymbol, setFilterSymbol] = useState("All");
  const [res, setRes] = useState<any>([]);
  const [tempRes, setTempRes] = useState<any>([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedSectorCode, setSelectedSectorCode] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [securityType, setSecurityType] = useState("");
  let [changePass, setChangePAssword] = useState<number>(1);
  const [modalFlag, setModalFlag] = useState("");
  const { customStyles } = useCustomStylesDropDown();
  const [currentSecurityStatus, setCurrentSecurityStatus] = useState("");
  // const [currentFundSecurityStatus, setCurrentFundSecurityStatus] = useState('');
  const [code, setCode] = useState("");
  const [securityLoading, setSecurityLoading] = useState(false);
  const [statusSetPopupFundSecurity, setStatusSetPopupFundSecurity] =
    useState(false);

  const updateStatus = async (symbolParam = "", statusParam = "") => {
    setbranchLoading(true);
    let status = "";
    let BranchStatus = statusParam ? statusParam : currentBranchStatus;
    if (BranchStatus === "active") {
      status = "deactive";
    } else {
      status = "active";
    }
    try {
      const response = await updateEquitySecurityStatus(
        email,
        symbolParam ? symbolParam : symbol,
        status,
        amc_code
      );
      if (response.data.status == 200) {
        toast.success(response.data.message);
        fetchAllPsxFiles();
        setbranchLoading(false);
        setFilterSymbol("All");
      } else {
        setbranchLoading(false);
        toast.error(response.data.message);
      }
      setStatusSetPopup(false);
    } catch (error: any) {
      setbranchLoading(false);
      if (error.response !== undefined) {
        toast.error(error.response.data.message?.toString());
      } else {
        toast.error("Request Failed!");
      }
    }
  };

  React.useEffect(() => {
    sessionStorage.removeItem("securityObj");
    const getSecurities = async () => {
      setLoading(true);
      try {
        const response = await getAllSecurities(
          email,
          activePage,
          pageSize,
          amc_code
        );
        if (response.data.data.length > 0) {
          let pageArr = paginationArr;
          let existingPageIndex = paginationArr.findIndex(
            (x) => x === response.data.page_info.next_page_number
          );
          if (
            existingPageIndex === -1 &&
            response.data.data.length === 10
            // &&
            // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
          ) {
            pageArr.push(response.data.page_info.next_page_number);
          }
          setPaginationArr(pageArr);
          setData(response.data.data);
          setTempRes(response.data.data);
        } else {
          setData([]);
          setTempRes([]);
          toast.error(response.data.message);
        }
      } catch (err: any) {
        // toast.error(error.response.data.message);
        if (err.response !== undefined) {
          toast.error(err.response.data.message?.toString());
        } else {
          toast.error("Request Failed!");
        }
      }
      setLoading(false);
    };
    getSecurities();
  }, [activePage]);

  const [allFundSecurities, setAllFundSecurities] = useState<any>([]);
  const fetchFundSecurity = async () => {
    setLoading(true);
    try {
      const response = await getAllFundSecurity(email);
      setAllFundSecurities(response.data.data);
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error(err.message);
      }
    }
    setLoading(false);
  };

  const fetchAllPsxFiles = async () => {
    setLoading(true);
    try {
      const response = await getAllPsx(email, amc_code);
      setPsxList(response.data.data);
      setTempPsxList(response.data.data);
    } catch (err: any) {
      // toast.error(error.response.data.message);
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Request Failed!");
      }
    }
    setFilterSymbol("All");
    setLoading(false);
  };

  //here we are rendering psx files list in equity tab
  const renderPsxData = () => {
    return psxList.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td
            style={{
              // width: "120px",
              maxWidth: "155px",
            }}
          >
            {items?.date
              ? moment(items?.date)?.format("MM-DD-YYYY")
              : moment()?.format("MM-DD-YYYY")}
          </td>
          <td
            style={{
              // width: "120px",
              maxWidth: "155px",
            }}
          >
            {items.company_name}
          </td>
          <td
            style={{
              // width: "120px",
              maxWidth: "155px",
            }}
          >
            {items.symbol}
          </td>
          <td
            style={{
              // width: "12px",
              maxWidth: "125px",
            }}
          >
            {items.sector_code}
          </td>
          <td>{items.open_rate}</td>
          <td>{items.high_rate}</td>
          <td>{items.low_rate}</td>
          <td>{items.close_rate}</td>
          <td>{items.volume}</td>
          <td>{items.ldcp}</td>
          <td>
            <div className="multi-icons pointer">
              <div
                // className="mr-3"
                onClick={() => {
                  setStatusSetPopup(true);
                  setCurrentBranchStatus(items.active);
                  setSymbol(items.symbol);
                }}
              >
                {items.active !== "active" ? (
                  <button
                    type="button"
                    className="btn-icon btn-link like btn btn-danger btn-sm"
                  >
                    <i className="tim-icons icon-simple-remove"> </i>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn-icon btn-link like btn btn-success btn-sm"
                  >
                    <i className="fa fa-check"></i>
                  </button>
                )}
              </div>
              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  sessionStorage.setItem(
                    "securityEquityObj",
                    JSON.stringify(items)
                  );
                  setModalFlag("View");
                  // history.replace("/admin/view-equity-security");
                }}
              >
                <i className="fa fa-eye"></i>
              </button>

              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  sessionStorage.setItem(
                    "securityEquityObj",
                    JSON.stringify(items)
                  );
                  setModalFlag("Edit");
                  // history.replace("/admin/edit-equity-security");
                }}
              >
                <i className="fa fa-edit"></i>
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  const renderUpdateEquitySecurityStatusPopup = () => {
    switch (statusSetPopup) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal60w"
            // show={true}
            show={statusSetPopup}
            // size="xl"
            backdrop={true}
            onHide={() => {
              setStatusSetPopup(false);
            }}
          >
            <div className="modal-header justify-content-center">
              <button
                aria-hidden="true"
                className="close"
                onClick={() => {
                  setStatusSetPopup(false);
                }}
                data-dismiss="modal"
                type="button"
              >
                <i className="tim-icons icon-simple-remove"></i>
              </button>
              <h6 className="title title-up">Action</h6>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <Row>
                  <div className="mx-auto">
                    {currentBranchStatus === "active" ? (
                      <img src="assets/ban.svg" alt="" width="70" />
                    ) : (
                      <img src="assets/check.svg" alt="" width="70" />
                    )}
                    <h1 className="pb-3">Are You Sure?</h1>
                    Are you sure you want to{" "}
                    {currentBranchStatus === "active"
                      ? "Deactivate"
                      : "Activate"}{" "}
                    this Security?
                  </div>
                </Row>
                <Row>
                  <Col>
                    <div className="">
                      <button
                        className="btn btn-primary"
                        disabled={Boolean(branchLoading)}
                        onClick={() => {
                          updateStatus();
                        }}
                      >
                        {branchLoading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          "Yes"
                        )}
                      </button>
                    </div>
                  </Col>
                  <Col>
                    <div className="">
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          setStatusSetPopup(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };

  const updateFundSecurityStatus = async () => {
    setSecurityLoading(true);
    let status = "";
    if (currentSecurityStatus === "active") {
      status = "deactive";
    } else {
      status = "active";
    }
    try {
      const response = await updateFundSecuritySecurityStatus(
        email,
        code,
        status
      );
      if (response.data.status === 200) {
        toast.success(response.data.message);
        setLoading(true);
        setTimeout(() => {
          fetchFundSecurity();
        }, 3000);
        setStatusSetPopupFundSecurity(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (error: any) {
      if (error.response.data.status === 500) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.response.data.message);
      }
    }
    setSecurityLoading(false);
  };

  const renderSelectSecurity = () => {
    return [
      {
        label: "Money Market",
        options: moneyMarket,
      },
      {
        label: "Debt Market",
        options: debtMarket,
      },
      {
        label: "Term Deposits",
        options: termDeposits,
      },
      {
        label: "Bai Mujjal Placement",
        options: baiMujjalPlacement,
      },
    ];
  };

  const selectedCompanyName = React.useMemo(() => {
    const selectedFund = companyArr?.find(
      (item) => item?.value === selectedCompany
    );
    return selectedFund
      ? {
          value: selectedFund?.value,
          label: selectedFund?.label,
        }
      : null;
  }, [companyArr, selectedCompany]);

  const selectedSecuritytype = React.useMemo(() => {
    const selectedFund = moneyMarket
      ?.concat(debtMarket, termDeposits, baiMujjalPlacement)
      ?.flat(1)
      ?.find((item) => item?.value === securityType);
    return selectedFund
      ? {
          value: selectedFund.value,
          label: selectedFund.label,
        }
      : null;
  }, [securityType]);

  React.useEffect(() => {
    if (data) {
      let i;
      res.length = 0;
      setRes(res);
      for (i = 0; i < data.length; i++) {
        res.push(data[i]);
        setRes(res);
      }
    }
  }, [data]);

  const resetFields = () => {
    setSelectedCompany("");
    setSelectedSectorCode("");
    setFilterSymbol("");
  };

  const renderData = () => {
    return res.map((items: any, index: any) => {
      return (
        <tr key={index}>
          <td>{items.security_type}</td>
          <td>{items.code.replace("SECURITY_", "")}</td>
          <td>{items.name}</td>
          <td>
            {items.issue_date
              ? moment(items.issue_date).format("YYYY-MM-DD")
              : ""}
          </td>
          <td>
            {items.maturity_date
              ? moment(items.maturity_date).format("YYYY-MM-DD")
              : ""}
          </td>
          <td>{items.face_value}</td>
          <td>{items.price}</td>
          <td>
            {/* <ReactTooltip	
              textColor="white"	
              backgroundColor="black"	
              effect="float"	
            />	 */}
            <div className="multi-icons pointer">
              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  sessionStorage.setItem("securityObj", JSON.stringify(items));
                  history.replace("/admin/view-security");
                }}
              >
                <i className="fa fa-eye"></i>
              </button>

              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  sessionStorage.setItem("securityObj", JSON.stringify(items));
                  history.replace("/admin/edit-security");
                }}
              >
                <i className="fa fa-edit"></i>
              </button>

              {/* <RiFilter2Fill	 className="mt-2 ml-1"
                data-tip="Filter it Uses"	
                onClick={() => {	
                  history.replace('/admin/security-transactions');	
                  sessionStorage.setItem('securityName', items.name);	
                }}	
              />	 */}
            </div>
          </td>
        </tr>
      );
    });
  };
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState("");
  const myRef1 = useRef<HTMLInputElement>(null);
  const uplaodFilePsx = async (fileDate: any) => {
    setFileUploadingFlag(true);
    await uploadPsxFile(
      sessionStorage.getItem("email") || "",
      fileDate,
      amc_code
    )
      .then((response) => {
        if (response.data.status === 200) {
          toast.success(response.data.message);
          setTimeout(() => {
            fetchAllPsxFiles();
          }, 2000);
          setFileName("");
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {});
    setFileUploadingFlag(false);
  };

  const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
  const upload = (e: any) => {
    setFileError("");
    let file = e?.target.files[0];
    let type = file.name.substring(file.name.lastIndexOf(".") + 1);
    if (type === "lis") {
      setFile(file);
      setFileName(file.name);
      uplaodFilePsx(e?.target.files[0]);
    } else {
      toast.error("Please Upload Correct Format of File");
    }
  };

  const filterAdvanced = (searchTerm) => {
    let tempData = tempPsxList;
    if (searchTerm) {
      let temp = tempData?.filter((item) =>
        Object?.values(item)
          ?.join(" ")
          ?.toLowerCase()
          ?.includes(searchTerm?.toLowerCase())
      );
      setPsxList(temp);
    } else {
      setPsxList(tempPsxList);
    }
  };

  const handlebtnFilter = (type = "") => {
    setSelectedCompany("");
    let tempArr = tempPsxList;
    if (type === "Active") {
      setPsxList(tempArr.filter((item) => item?.active === "active"));
    } else if (type === "Inactive") {
      setPsxList(tempArr.filter((item) => item?.active === "deactive"));
    } else if (type === "Future Active") {
      setPsxList(
        tempArr
          .filter((item) => item?.active === "active")
          ?.filter((ele) => {
            if (ele?.symbol?.includes("-")) {
              return true;
            } else {
              return false;
            }
          })
      );
    } else if (type === "Future InActive") {
      setPsxList(
        tempArr
          .filter((item) => item?.active === "deactive")
          ?.filter((ele) => {
            if (ele?.symbol?.includes("-")) {
              return true;
            } else {
              return false;
            }
          })
      );
    } else {
      setPsxList(tempPsxList);
    }
  };

  const renderFundSecurityData = () => {
    // return
    return allFundSecurities.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td style={{ width: "45%" }}>{items.name}</td>
          <td>{items.code}</td>
          <td className="text-right">
            {numberWithCommas(isNumber(parseFloat(items.price).toFixed(4)))}
          </td>
          <td className="captilize">{items.status}</td>
          <td>
            <ReactTooltip
              textColor="white"
              backgroundColor="black"
              effect="float"
            />
            <div className="multi-icons pointer">
              <div
                className="mr-3 pointer"
                onClick={() => {
                  setCurrentSecurityStatus(items.status);
                  setCode(items.code);
                  setStatusSetPopupFundSecurity(true);
                }}
              >
                {items.status !== "active" ? (
                  <button
                    type="button"
                    className="btn-icon btn-link like btn btn-danger btn-sm"
                  >
                    <i className="tim-icons icon-simple-remove"></i>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn-icon btn-link like btn btn-success btn-sm"
                  >
                    <i className="fa fa-check"></i>
                  </button>
                )}
              </div>

              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  sessionStorage.setItem(
                    "fundSecurityObj",
                    JSON.stringify(items)
                  );
                  history.replace("/admin/view-fund-security");
                }}
              >
                <i className="fa fa-eye"></i>
              </button>

              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  sessionStorage.setItem(
                    "fundSecurityObj",
                    JSON.stringify(items)
                  );
                  // sessionStorage.setItem('allFundObj', JSON.stringify(allFundSecurities));
                  history.replace("/admin/edit-fund-security");
                }}
              >
                <i className="fa fa-edit"></i>
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  const renderUpdateFundSecurityStatusPopup = () => {
    if (statusSetPopupFundSecurity === true) {
      return (
        <Modal
          className=""
          dialogClassName="modal60w"
          enforceFocus={false}
          show={true}
        >
          <div className="modal-header justify-content-center">
            <button
              aria-hidden="true"
              className="close"
              onClick={() => {
                setStatusSetPopupFundSecurity(false);
              }}
              data-dismiss="modal"
              type="button"
            >
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h6 className="title title-up">Action</h6>
          </div>
          <div className="modal-body">
            <div className="text-center">
              <Row>
                <div className="mx-auto">
                  {currentSecurityStatus === "active" ? (
                    <img src="assets/ban.svg" alt="" width="70" />
                  ) : (
                    <img src="assets/check.svg" alt="" width="70" />
                  )}
                  <h1 className="pb-3">Are You Sure?</h1>
                  Are you sure you want to{" "}
                  {currentSecurityStatus === "active"
                    ? "Deactivate"
                    : "Activate"}{" "}
                  this Security?
                </div>
              </Row>
              <Row>
                <Col>
                  <div className="">
                    <button
                      className="btn btn-primary"
                      disabled={Boolean(securityLoading)}
                      onClick={() => {
                        updateFundSecurityStatus();
                      }}
                    >
                      {securityLoading ? (
                        <>
                          <span
                            className="spinner-border login-txt spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span className="login-txt"> Loading...</span>
                        </>
                      ) : (
                        "Yes"
                      )}
                    </button>
                  </div>
                </Col>
                <Col>
                  <div className="">
                    <button
                      className="btn btn-default"
                      onClick={() => {
                        setStatusSetPopupFundSecurity(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Modal>
      );
    } else {
      return "";
    }
  };

  const renderContent = () => {
    if (changePass === 1) {
      return (
        <div className="">
          <div className="">
            <Col xl={4} lg={4} md={6} sm={12} xs={12} className="pl-0">
              <div className="form-group">
                <label>Security Type</label>
                <div>
                  <div className="">
                    <Select
                      value={selectedSecuritytype}
                      label={"Select Security"}
                      onChange={(e) => {
                        setSecurityType(e?.value);
                        let value = e?.value;
                        let tempArr = tempRes;
                        if (value !== "" && value !== undefined) {
                          setRes(
                            tempArr?.filter((ele) => {
                              return ele?.security_type == value;
                            })
                          );
                        } else {
                          setRes(tempRes);
                        }
                      }}
                      menuPortalTarget={document.body}
                      menuShouldBlockScroll={true}
                      isClearable={true}
                      isSearchable={true}
                      name="color"
                      options={renderSelectSecurity()}
                      styles={customStyles}
                    />
                  </div>
                </div>
              </div>
            </Col>
            <button
              className="btn btn-primary btn-sm ml-4 float-right"
              onClick={() => {
                history.push("/admin/setup-security");
              }}
            >
              <i className="fa fa-plus mr-2"></i> Add New
            </button>
          </div>
          {res?.length > 0 ? (
            <div className="table-responsive">
              <table className="table ">
                <thead>
                  <tr>
                    <th>Security Type</th>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Issue Date</th>
                    <th>Maturity Date</th>
                    <th>Face Value</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{renderData()}</tbody>
              </table>
              {!isSearchActive && (
                <div
                  className="row pr-3 pointer"
                  style={{
                    float: "right",
                  }}
                >
                  {/* PREVIOUS BUTTON */}
                  {activePage !== paginationArr[0] ? (
                    <i
                      className="fa fa-arrow-left"
                      aria-hidden="true"
                      onClick={() => {
                        let pageArr = paginationArr;
                        let index = pageArr.findIndex((x) => x === activePage);
                        if (index !== -1) {
                          setActivePage(paginationArr[index - 1]);
                        }
                      }}
                    ></i>
                  ) : (
                    ""
                  )}
                  {/* NEXT BUTTON */}
                  {activePage !== paginationArr[paginationArr.length - 1] ? (
                    <i
                      className="fa ml-3 fa-arrow-right"
                      aria-hidden="true"
                      onClick={() => {
                        let pageArr = paginationArr;
                        let index = pageArr.findIndex((x) => x === activePage);
                        if (index !== -1) {
                          setActivePage(paginationArr[index + 1]);
                        }
                      }}
                    ></i>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              <b>No data found!</b>
            </div>
          )}
        </div>
      );
    } else if (changePass === 2) {
      return (
        <div>
          <Row>
            <div className="input-holder">
              <div>
                <button
                  className="btn btn-primary btn-sm ml-3"
                  onClick={() => {
                    // history.push("/admin/setup-equity-security");
                    setModalFlag("Add");
                  }}
                >
                  <i className="fa fa-plus mr-2"></i> Add New
                </button>
                {ActiveSecurity?.map((item, index) => {
                  return (
                    <button
                      key={index}
                      id={
                        item?.value == filterSymbol
                          ? ""
                          : "outlined_button_primary"
                      }
                      className={`rounded-pill fs btn btn-primary btn-sm ${
                        item?.value == filterSymbol ? "" : "border"
                      }`}
                      onClick={() => {
                        if (item?.value !== filterSymbol) {
                          setFilterSymbol(item?.value);
                          handlebtnFilter(item?.value);
                        }
                      }}
                    >
                      {item?.label}
                    </button>
                  );
                })}
              </div>
              <div
                className="multi-input ml-auto"
                onClick={() => myRef1?.current?.click()}
              >
                <div className="form-group">
                  <div className="form-control">
                    {fileName === "" ? "Upload File" : fileName}
                  </div>
                  <input
                    type="file"
                    ref={myRef1}
                    style={{ display: "none" }}
                    multiple={false}
                    onChange={(e) => {
                      upload(e);
                    }}
                  />
                  {fileError ? (
                    <p className="error-labels error-message2">{fileError}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {fileUploadingFlag && (
                <i className="fa fa-spinner fa-spin fa-1x"></i>
              )}
            </div>
          </Row>
          <Row>
            <Col xl={3} lg={4} md={6} sm={12} xs={12}>
              <div className="form-group">
                <label>Select Sector</label>
                <Select
                  value={selectedCompanyName}
                  placeholder="Select Sector"
                  onChange={(e) => {
                    const selectedCompany = e?.value || "";
                    setSelectedCompany(selectedCompany);
                    setFilterSymbol("All");
                    let tempArrr = tempPsxList;
                    const finalFilteredList = selectedCompany
                      ? tempArrr.filter(
                          (item) => item?.sector_code === selectedCompany
                        )
                      : tempArrr;

                    setPsxList(finalFilteredList);
                  }}
                  // onChange={(e) => {
                  //   const selectedCompany = e?.value || "";
                  //   setSelectedCompany(selectedCompany);

                  //   let tempArrr = tempPsxList
                  //   const getFilteredBySecurityType = (): any[] => {
                  //     switch (filterSymbol) {
                  //       case "Active":
                  //         return tempArrr.filter((item) => item?.active === "active");

                  //       case "Inactive":
                  //         return tempArrr.filter((item) => item?.active === "deactive");

                  //       case "Future Active":
                  //         return tempArrr
                  //           .filter((item) => item?.active === "active")
                  //           .filter((item) => item?.symbol?.includes("-"));

                  //       case "Future InActive":
                  //         return tempArrr
                  //           .filter((item) => item?.active === "deactive")
                  //           .filter((item) => item?.symbol?.includes("-"));

                  //       default:
                  //         return tempPsxList;
                  //     }
                  //   };

                  //   const filteredBySecurityType = getFilteredBySecurityType();

                  //   const finalFilteredList = selectedCompany
                  //     ? filteredBySecurityType.filter((item) => item?.sector_code === selectedCompany)
                  //     : filteredBySecurityType;

                  //   setPsxList(finalFilteredList);
                  // }}
                  menuPortalTarget={document.body}
                  menuShouldBlockScroll
                  isClearable
                  isSearchable
                  name="company"
                  options={companyArr}
                  styles={customStyles}
                />
              </div>
            </Col>
          </Row>

          {!Loading ? (
            psxList?.length > 0 ? (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th
                        style={{
                          // width: "12px",
                          maxWidth: "125px",
                        }}
                      >
                        Date
                      </th>
                      <th
                        style={{
                          // width: "12px",
                          maxWidth: "125px",
                        }}
                      >
                        Company Name
                      </th>
                      <th
                        style={{
                          // width: "120px",
                          maxWidth: "155px",
                        }}
                      >
                        Symbol
                      </th>
                      <th
                        style={{
                          // width: "12px",
                          maxWidth: "125px",
                        }}
                      >
                        Sector Code
                      </th>
                      <th>Open Rate</th>
                      <th>High Rate</th>
                      <th>Low Rate</th>
                      <th>Close Rate</th>
                      <th>Volume</th>
                      <th>LDCP</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{renderPsxData()}</tbody>
                </table>
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <b>No data found!</b>
              </div>
            )
          ) : (
            <div className="d-flex">
              <img src="assets/loader.svg" width="100" />
            </div>
          )}
        </div>
      );
    } else if (changePass === 3) {
      return (
        <div>
          <div className="">
            <button
              className="btn btn-primary btn-sm ml-4 float-right"
              onClick={() => {
                history.replace("/admin/setup-fund-security");
              }}
            >
              <i className="fa fa-plus mr-2"></i> Add New
            </button>
          </div>

          {!Loading ? (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Security Name</th>
                    <th>Code</th>
                    <th className="text-right">Price</th>
                    <th>Status</th>
                    <th>action</th>
                  </tr>
                </thead>
                <tbody>{renderFundSecurityData()}</tbody>
              </table>
            </div>
          ) : (
            <div className="d-flex">
              <img src="assets/loader.svg" width="100" />
            </div>
          )}
        </div>
      );
    }
  };

  const handleUpdateFutureSymbols = async () => {
    const symbolsToUpdate = tempPsxList
      ?.filter((ele) => ele?.active === "active")
      ?.filter((ele) => {
        if (ele?.symbol?.includes("-")) {
          const symbolParts = ele?.symbol?.split("-");
          if (symbolParts[1]) {
            const symbolMonth = moment(symbolParts[1]?.slice(0, 3), "MMM"); // just getting only 3 Characters of Month
            const currentDate = moment(); // for today date
            const nextMonth = moment().add(1, "month").startOf("month"); // for tommorow month like is current month is sep than get next oct
            if (
              symbolMonth?.isBefore(currentDate, "month") ||
              symbolMonth?.isAfter(nextMonth, "month")
            ) {
              // check whether the date month is before current or after current + 1 month means after oct
              return true;
            } else {
              return false;
            }
          }
        }
        return false;
      })
      ?.map((ele) => ele?.symbol);

    if (!symbolsToUpdate || symbolsToUpdate.length === 0) {
      toast.info("No future symbols found to update.");
      return;
    }

    try {
      setLoadingAllStatusChange(true);
      let res = await bulkStatusChange(email, symbolsToUpdate, amc_code);
      if (res.data.status == 200) {
        toast.success(res?.data.message);
        fetchAllPsxFiles();
        setbranchLoading(false);
      } else {
        toast.error("Error updating Bulk Status");
      }
    } catch (error) {
      toast.error("An error occurred while updating one or more symbols.");
      console.error("Batch update error:", error);
    } finally {
      setLoadingAllStatusChange(false);
      setStatusSetPopup(false);
      fetchAllPsxFiles();
    }
  };

  return (
    <>
      <div className="content">
        {/* ---------------- View Modal ------------ */}
        <Modal
          className=""
          dialogClassName="modal90w"
          show={modalFlag}
          size="xl"
          backdrop={true}
          onHide={() => {
            setModalFlag("");
            sessionStorage?.removeItem("securityEquityObj");
          }}
          centered={true}
        >
          <div className="modal-header ">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setModalFlag("");
                sessionStorage?.removeItem("securityEquityObj");
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">{modalFlag} Equity</h6>
          </div>
          <div className="modal-body">
            {modalFlag === "Add" ? (
              <SetupEquitySecurity setModalFlag={setModalFlag} />
            ) : modalFlag === "Edit" ? (
              <EditEquitySecurity setModalFlag={setModalFlag} />
            ) : modalFlag === "View" ? (
              <ViewEquitySecurity />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="card">
                <div className="d-flex align-items-center"></div>

                {!Loading && !loadingAllStatusChange ? (
                  <div className="">
                    <div className="card-header d-flex justify-content-between">
                      <h4 className="card-title">Security Listing</h4>
                      {changePass === 2 ? (
                        <Button
                          onClick={() => {
                            handleUpdateFutureSymbols();
                          }}
                        >
                          Update Future Symbols
                        </Button>
                      ) : null}
                    </div>
                    <div className="card-body">
                      <div className="w-100 d-flex mt-4">
                        <div
                          onClick={() => {
                            setChangePAssword(1);
                            resetFields();
                          }}
                          className={`card border shadow box-report user-header mr-2 w-50 justify-content-center`}
                        >
                          {changePass === 1 && (
                            <ImCheckmark className="tick-noti tick-img" />
                          )}

                          <span className="card-title mb-0">Money Market</span>
                        </div>
                        <div
                          onClick={() => {
                            setChangePAssword(2);
                            fetchAllPsxFiles();
                            setSecurityType("");
                            setRes(tempRes);
                          }}
                          className={`card border shadow box-report user-header w-50 justify-content-center`}
                        >
                          {changePass === 2 && (
                            <ImCheckmark className="tick-noti tick-img" />
                          )}
                          <span className="card-title mb-0">Equity</span>
                        </div>
                        <div
                          onClick={() => {
                            setChangePAssword(3);
                            fetchFundSecurity();
                          }}
                          className={`card border shadow box-report user-header w-50`}
                        >
                          {changePass === 3 && (
                            <ImCheckmark className="tick-noti tick-img" />
                          )}
                          <span className="card-title">
                            Investment In Funds
                          </span>
                        </div>
                      </div>
                      {renderContent()}
                    </div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center my-5">
                    <i className="fa fa-spinner fa-spin fa-3x"></i>
                  </div>
                )}
              </div>
            </Container>
          </Col>
        </Row>
        {renderUpdateEquitySecurityStatusPopup()}
        {renderUpdateFundSecurityStatusPopup()}
      </div>
    </>
  );
};
export default SecurityList;
